import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";
import { GROUPS, STAFF } from "@/data/siteData";

export default function Training() {
  return (
    <section id="szkolenie" data-testid="training-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <span className="font-accent uppercase tracking-[0.3em] text-blue-700 text-xs font-bold">03 — Szkolenie</span>
        <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl text-[#0B1120]">
          Program dopasowany <span className="text-blue-700">do wieku</span>
        </h2>
        <p className="mt-6 max-w-2xl text-slate-600 text-base font-medium leading-relaxed">
          Każda grupa trenuje według indywidualnie dobranego programu, który zapewnia
          wszechstronny i prawidłowy psychomotoryczny rozwój dziecka.
        </p>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {GROUPS.map((g, i) => (
            <motion.div
              key={g.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              data-testid={`group-card-${i}`}
              className="border-2 border-[#0B1120] bg-[#F8FAFC] p-6 hover:shadow-[6px_6px_0_#1D4ED8] hover:-translate-y-1 transition-all duration-200"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-display font-black uppercase tracking-tight text-2xl text-[#0B1120] mr-2">{g.name}</h3>
                <span className="font-accent text-xs font-bold uppercase tracking-widest bg-[#FACC15] text-[#0B1120] px-2 py-1 border border-[#0B1120] shrink-0">
                  {g.ages}
                </span>
              </div>
              <p className="mt-4 text-sm text-slate-600 font-medium leading-relaxed">{g.desc}</p>
              <ul className="mt-5 space-y-2">
                {g.focus.map((f) => (
                  <li key={f} className="flex items-center gap-2 font-accent text-xs font-bold uppercase tracking-wide text-blue-700">
                    <span className="h-1.5 w-1.5 bg-[#FACC15] border border-[#0B1120]" />
                    {f}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <div className="mt-24">
          <div className="flex items-center gap-3">
            <GraduationCap className="text-blue-700" size={28} />
            <h3 className="font-display font-black uppercase tracking-tight text-3xl text-[#0B1120]">Sztab szkoleniowy</h3>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {STAFF.map((s, i) => (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                data-testid={`staff-card-${i}`}
                className="border border-slate-200 bg-white p-6 hover:border-blue-700 hover:-translate-y-1 transition-all duration-200"
              >
                <div className="h-12 w-12 bg-blue-700 text-white font-display font-black flex items-center justify-center text-lg uppercase">
                  {s.name.split(" ").map((n) => n[0]).join("")}
                </div>
                <h4 className="mt-4 font-display font-black uppercase tracking-tight text-lg text-[#0B1120]">{s.name}</h4>
                <span className="font-accent text-[11px] font-bold uppercase tracking-widest text-[#FACC15] bg-[#0B1120] px-2 py-0.5 inline-block mt-1">
                  {s.role}
                </span>
                <p className="mt-3 text-sm text-slate-600 font-medium leading-relaxed">{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
